var Report = require('@tencent/yyb-fe-report');

var state2Action = {
	1: 900, // 下载
    2: 905, // 更新
    3: 200, // 等待
    4: 200, // 暂停
    5: 200, // 继续
    6: 305, // 安装
    7: 200, // 下载中
    8: 500 // 打开
};

var apps = {}; // 存储APP的信息
    var cache = {}; // 方便根据id查询到app
    var pkgName2AppId = {};
    var appId2PkgName = {};
    var lastState = {};

var queryCallbacks = []; // 查询app下载状态之后的回调函数

var appManager = {
    reg: function(appList, params) { // 初始化，创建下载
        params = params || {}; // 统计上报相关的字段，有scene sourceScene, slotId
        appList.forEach(function(app) {
            if (apps[app.appId]) return; // 如果创建了，则返回
            pkgName2AppId[app.packageName] = app.appId;
            appId2PkgName[app.appId] = app.packageName;
            cache[app.appId] = app;
            var arg = {
                // 应用宝下载字段
                packageName: app.packageName,
                hnAppId: app.appId,
                appName: app.appName,
                reCreate: app.reCreate || 0,
                autoOpen: app.autoOpen || params.autoOpen || 0,
                autoStart: app.autoStart || params.autoStart || 0,
                noWifiDialogShow: app.noWifiDialogShow || params.noWifiDialogShow || false,
                // 手Q、微信下载必须字段
                apkid: app.apkId || '',
                sngAppId: app.sngAppId,
                signature: app.signature,
                url: app.apkUrl,
                md5: app.md5,
                thumb_url: app.thumb_url || app.iconUrl,
                // 更新逻辑必备
                checkUpdate: app.checkUpdate == undefined ? 1 : app.checkUpdate,
                versionCode: app.versionCode,
                // 其他
                channelId: app.channelId,
                iconUrl: app.iconUrl,
                versionName: app.versionName,
                fileSize: app.fileSize,
                // 上报
                slotId: app.slotId || params.slotId,
                scene: app.scene || params.scene,
                status: app.status || params.status || '',
                sourceScene: app.sourceScene || params.sourceScene || '',
                sourceSceneSlotId: app.sourceSceneSlotId || params.sourceSceneSlotId || '',
                subPosition: app.subPosition || params.subPosition || '',
                recommendId: app.recommendId || params.recommendId || '',
                appSource: app.appSource || params.appSource || '',
                via: app.via || params.via || '',
                params: app.extraData || params.extraData || ''
            };
            if (!arg.scene) {
                console.error('Missing scene');
            }
            if (!arg.slotId) {
                console.warn('Missing scene');
            }
            // 创建之后的回调
            var fn = function() {
                appManager._downloadCallback.apply(this, arguments);
            };
            if (!apps[app.appId]) {
                var ua = navigator.userAgent;
                if (ua.match(/\/qqdownloader\/(\d+)(?:\/(appdetail|external))?/)) {
                    // 应用宝中才会判断
                    JsBridge.call('queryDownload', {
                        appid: arg.hnAppId,
                        packagename: arg.packageName
                    }, function(data) {
                        // 是否为静默下载
                        var isWiseDownload = false;
                        if (data.data) {
                            var queryRes = JSON.parse(data.data) || {};
                            if (queryRes.uiType === 'WISE_SILENT_DOWNLOAD') {
                              isWiseDownload = true;
                            }
                          }
                          if (isWiseDownload) {
                            JsBridge.call('deleteDownload', {
                                isNoConfirm: 1,
                                packagename: arg.packageName,
                              }, function() {
                                apps[app.appId] = new JsBridge.Download(arg, fn, app.context);
                              });
                          } else {
                            apps[app.appId] = new JsBridge.Download(arg, fn, app.context);
                          }
                    });
                } else {
                    apps[app.appId] = new JsBridge.Download(arg, fn, app.context);
                }
            }
        });
    },
    _downloadCallback: function(state, pro, context, info) {
        info.packageName = info.packageName || this.args.packageName;
        var appId = appId2PkgName[info.packageName];
        info.appId = this.args.hnAppId; // 被全appid;
        info.instance = this; // 被全appid;
        this.info = info;
        pro = this.percentage = pro || info.down_percent || this.percentage || 0;
        apps[info.appId] = apps[info.appId] || this;

        // 记录最后一次状态变化，用于重新触发状态
        lastState[info.appId] = [state, pro, context, info];

        queryCallbacks.forEach(function(qcb) {
            qcb(state, pro, context, info);
        });
    },
    queryAppState: function(qcb) { // 查询app下载状态
        queryCallbacks.push(qcb);
    },
    doAction: function(appId, reportData) {
        if (!apps[appId]) return;
        if (reportData) {
            var state = appManager.getDownloader(appId).state;
            reportData['action'] = state2Action[state];
            Report.send(reportData);
        }
        apps[appId].doAction();
    },
    getDownloader: function(appId) {
        return apps[appId];
    },
    getAppInfo: function(appId) {
        return cache[appId];
    },
    clearAppCache: function() {
        apps = {};
    },
    reTriggerStateChange: function(appid) {
        if (appid) {
            var args = lastState[appid];
            if (args && args.length) {
                queryCallbacks.forEach(function(l) {
                    l(args[0], args[1], args[2], args[3]);
                });
            }
        } else {
            for (var aid in lastState) {
                this.reTriggerStateChange(aid);
            }
        }
    }
};

module.exports = appManager;